export function salabelItemFactory($resource, MyConstant) {
    "ngInject"

    return $resource('', {}, {
        get: {
            url: `${MyConstant.ApiUrl}ECBTempGeneral/GetSalableItemsByProductID?productID=:productID`,
            params: {
                SortField: 'bestSeller',
                sortAsc: false,
                RowsPerPage: 12,
                pageNumber: 1
            },
            method: 'POST'
        },
        remove: {
            method: 'GET',
            url: `${MyConstant.ApiUrl}SalableItemManagement/RemoveSalableItem/?SalableItemID=:SalableItemID`,
        },
    })
}


// WEBPACK FOOTER //
// ./src/factories/salabel-item/salabel-item.ts